import * as config from "../app.config";
import { getUserId, getAccessToken } from "./Okta";
import axios from "axios";
import moment from "moment";

export const USER_MESSAGE = "USER_MESSAGE";

export function setHeaders() {
  const accessToken = getAccessToken();
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };
  return headers;
}

export function sendFeedback(values) {
  return (dispatch, getState) => {
    const userId = getUserId();
    if (!userId) {
      return false;
    }

    const headerConfig = setHeaders();
    const postData = {
      userMessage: values.userMessage
    };

    axios
      .post(`${config.ENDPOINTS["main"]}/sendfeedback`, postData, {
        headers: headerConfig
      })
      .then(resp => {
        dispatch({
          type: USER_MESSAGE,
          msgType: "success",
          text: "Message sent successfully",
          key: moment().unix()
        });
      })
      .catch(err => {
        dispatch({
          type: USER_MESSAGE,
          msgType: "error",
          text: "Message was not sent successfully",
          key: moment().unix()
        });
      });
  };
}

export function clearMessage() {
  return (dispatch, getState) => {
    dispatch({ type: USER_MESSAGE, msgType: "", text: "", key: "" });
  };
}
